import { render, staticRenderFns } from "./page.vue?vue&type=template&id=470f42d0&scoped=true&"
import script from "./page.vue?vue&type=script&lang=js&"
export * from "./page.vue?vue&type=script&lang=js&"
import style0 from "./page.vue?vue&type=style&index=0&id=470f42d0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470f42d0",
  null
  
)

export default component.exports